export const INTRO_END_SPLASH_SRC = `${process.env.PUBLIC_URL}/wildsea-end.png`;
export const INTRO_START_SPLASH_SRC = `${process.env.PUBLIC_URL}/wildsea-splash.png`;
